(function($) {

    $(".nav-toggle").on('click', function () {
       $nav = $("nav.mobile-nav");
       if($(this).hasClass('search')){
           $(".mobile-navbar .search_form").toggleClass('show');
           $(".nav-toggle").toggleClass('open search');
       } else{
           $(this).toggleClass("open");
           $nav.toggleClass('show');
           $('html').toggleClass('mobile-nav-open');
       }
    });

    $(".bottom-nav li").on("mouseenter mouseleave", function () {
        if($(window).width() > 992) {
            $(this).toggleClass('show');
        }
    });
    if($(window).width() < 992) {
        $(".mobile-nav li.menu-item-has-children").prepend('<div class="chevron"></div>');
    }
    $(".mobile-nav li.menu-item-has-children").on("click", function (e) {
        if($(window).width() < 992) {
            // e.preventDefault();
            $(this).toggleClass('show');
            $(".mobile-nav li.menu-item-has-children").not(this).children('.sub-menu').slideUp();
            $(this).children('.sub-menu').slideToggle();
        }
    });
    $(".trigger-search").on('click', function () {
        $(".left-nav, .right-nav").fadeToggle();
        $(".search_form").toggleClass('show');
        $(".search_form_close").toggleClass('show');
        $(".nav-toggle").toggleClass('open search');
    });

    $(".search_form_close").on('click', function () {
        $(".left-nav, .right-nav").fadeToggle();
        $(".search_form").toggleClass('show');
        $(this).toggleClass('show');
    });

    $(".bottom-nav li").each(function () {

        if($(this).hasClass('search')){
            $(this).append('<form class="search_form" action="/" method="GET"><div class="input-container"><input type="text" name="s" id="text" class="msoSearchBox" value="" autoComplete="off" placeholder="Search" data-min="14" data-max="18" data-pref="1"><div class="line"></div></div><button type="submit" class="msoSearchBtn"><i class="fa fa-search" aria-hidden="true"></i></button></form>');
        }
    });

    const $window = $(window);

    $window.on("load resize", function() {

        $(".search_form input").each(function() {
            let $this = $(this);
            let $min = $this.data('min');
            let $max = $this.data('max');
            let $pref = $this.data('pref');

            let $font = getFontClampSize($min, $max, $pref);
            $this.css('font-size', $font + 'px');
        });

        function getFontClampSize($min, $max, $pref) {
            $windowWidth = $window.width();
            let basePref = ($windowWidth * $pref) / 100;
            if(basePref > $max) {
                return $max;
            } else if (basePref < $min) {
                return $min;
            } else {
                return Math.ceil(basePref);
            }
        }


    });

    $window.on("load resize", function() {
        $('span.placeholder').remove();
        setTimeout( function(){
            var input = $('.search_form input');
            var placeholderText = input.attr('placeholder');
            var placeholder = $('<span class="placeholder">').text(placeholderText).css({
                'font-size': 'clamp(14px, 1.5vw, 18px)',
                'font-family': input.css('font-family'),
                'font-weight': input.css('font-weight'),
                'letter-spacing': input.css('letter-spacing'),
                'visibility': 'hidden',
                'text-transform': 'uppercase',
            });
            $('body').append(placeholder);
            var width = placeholder.width();
            input.width(width);
        }, 10 );
    });

})( jQuery );

